@if(data && data.length > 0){ @for(question of data; track
question.key_question){
<div class="col gap-4">
    <h4 class="strong">{{ question.key_question }}</h4>
    @if(state === false){
    <div class="tiny">
        {{ question.answer }}
    </div>
    }@else{
    <rr-textarea
        [(ngModel)]="question.answer"
        [class.edited]="question.dirty"
        [attr.placeholder]="'Edit value'"
        [fitText]="true"
        class="w100"
    />
    }
</div>
} }
